import { useState } from 'react';
import {
    Box,
    Typography,
    IconButton,
    Chip,
    Grid,
    Divider,
    Card,
    CardContent,
    Collapse,
} from '@mui/material';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

// Sortierbare Übungs-Karte innerhalb eines eigenen Trainingsplans.
function PlanUebungCard({ uebung, onEdit, onDelete, isDragging }) {
    const [expanded, setExpanded] = useState(false);
    const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id: uebung.id });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.5 : 1,
    };

    return (
        <Card
            ref={setNodeRef}
            style={style}
            sx={{
                mb: 2,
                bgcolor: 'background.paper',
                border: '1px solid',
                borderColor: 'divider',
                touchAction: 'pan-y',
            }}
        >
            <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
                <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
                    <Box display="flex" alignItems="center" gap={1} flex={1}>
                        <IconButton
                            {...attributes}
                            {...listeners}
                            size="small"
                            sx={{
                                cursor: isDragging ? 'grabbing' : 'grab',
                                touchAction: 'none',
                                flexShrink: 0
                            }}
                        >
                            <DragIndicatorIcon />
                        </IconButton>
                        <Box flex={1}>
                            <Typography variant="h6" sx={{ fontSize: { xs: '1rem', sm: '1.25rem' } }}>
                                {uebung.uebung_name}
                            </Typography>
                            <Box display="flex" gap={1} flexWrap="wrap" mt={0.5}>
                                <Chip label={uebung.zielmuskel} size="small" color="primary" variant="outlined" />
                                <Chip label={uebung.kategorie} size="small" color="secondary" variant="outlined" />
                            </Box>
                        </Box>
                    </Box>
                    <Box display="flex" gap={0.5}>
                        <IconButton onClick={() => setExpanded(!expanded)} size="small">
                            {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                        </IconButton>
                        <IconButton onClick={onEdit} size="small" color="warning">
                            <EditIcon />
                        </IconButton>
                        <IconButton onClick={onDelete} size="small" color="error">
                            <DeleteIcon />
                        </IconButton>
                    </Box>
                </Box>

                <Collapse in={expanded}>
                    <Divider sx={{ my: 2 }} />
                    <Grid container spacing={2}>
                        <Grid>
                            <Typography variant="caption" color="text.secondary">Notizen</Typography>
                            <Typography variant="body2">{uebung.notizen || '-'}</Typography>
                        </Grid>
                    </Grid>
                </Collapse>
            </CardContent>
        </Card>
    );
}

export default PlanUebungCard;
